module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"claim.tickets":"Ticket ที่เกี่ยวข้อง","claim.tickets.description":"รายการ Ticket ที่เกี่ยวข้องกับใบงานนี้ โดยอาจจะมีการแนบ Ticket ที่สอบถามการเคลมไว้เพื่อความสะดวกกับการตรวจสอบของ HGR ครับ","claim.tickets.empty":"ยังไม่ได้ระบุ Ticket ที่เกี่ยวข้อง","claim.tickets.manage.button":"ระบุ Ticket ที่เกี่ยวข้อง"}}')
  delete Component.options._Ctor
}
